export const getRandomNumber = (min, max) => {
  return Math.random() * (max - min) + min;
}

export const AudioWaveArr = Array(20).fill(0).map((el) => ({height: getRandomNumber(8, 26)}))